import React from 'react';
import { useSelector } from 'react-redux';
import useListenSize from '../hooks/useListenSize';
import CheckCircle from '../assets/img/check-circle.png';
import { segmentEvent } from '../helpers/sendEvent';

// eslint-disable-next-line no-shadow
function Congratulation() {
  const store = useSelector(state => ({
    availableLimit: state.loanInfo?.availableLimit,
    firstName: state.personal?.firstName,
    retailerId: state.technical?.retailerId,
    retailerName: state.technical?.retailerName,
    retailerWebsite: state.technical?.retailerWebsite,
    uid: state.loanInfo?.uid,
  }));
  useListenSize();
  const goBackToRetailor = () => {
    segmentEvent('track', 'Synchrony Shop with retailer Submitted', {
      retailer_id: store.retailerId,
      retailer_name: store.retailerName,
      customer_name: store.firstName,
      customer_id: store.uid,
      pre_approval: store.availableLimit,
    });

    window.location.href = store.retailerWebsite;
  };

  const visitHowKatapultWorks = () => {
    localStorage.removeItem('synchronyRetailerToken');

    segmentEvent('track', 'Synchrony Learn more submitted', {
      retailer_id: store.retailerId,
      retailer_name: store.retailerName,
      customer_name: store.firstName,
      customer_id: store.uid,
      pre_approval: store.availableLimit,
    });

    window.location.href = 'https://katapult.com/how-it-works';
  };

  return (
    <div className="k-content-wrapper">
      <section className="k-info">
        <div className="k-error-image-wrapper">
          <img width="150" height="150" className="congratulation-icon" src={CheckCircle} alt="" />
        </div>
        <h1 className="congratulation-header">Congratulations {store.firstName}!</h1>
        <h3 className="congratulation-text">You are pre-approved to lease items with a cash price up to</h3>
        <h1 className="congratulation-amount">${store.availableLimit}</h1>
        <h3 className="congratulation-text">
          Complete your order online or in-store. For questions contact (retailer) for more information
        </h3>
        <div className="k-submit">
          <button type="button" onClick={goBackToRetailor}>
            Shop with {store.retailerName}
          </button>
        </div>
        <div className="k-submit congratulation-button">
          <button type="button" className="secondary-button" onClick={visitHowKatapultWorks}>
            Learn more about Katapult
          </button>
        </div>
      </section>
    </div>
  );
}

export default Congratulation;
